import React, { FunctionComponent } from 'react'

import { FormControlSelect } from './ListStyle'
import { LabelInputError } from '../StyledComponents/LabelInputError'
import { MenuItemWrapper, SelectWrapper } from '../wrapper'

interface IComponentProps {
  id: string
  value: string
  onClick: (value: string) => void
  lists: string[]
  minWidth: string
  error?: boolean
  textError?: string
  disabled?: boolean
  onBlur?: () => void
}

export const List: FunctionComponent<IComponentProps> = ({
  lists,
  id,
  value,
  onClick,
  minWidth,
  error,
  textError,
  disabled,
  onBlur,
}) => {
  return (
    <>
      <FormControlSelect
        style={{ minWidth: minWidth }}
        data-testid={id}
        error={error}
      >
        <SelectWrapper
          name={id}
          labelId={id}
          id={id}
          value={value}
          onChange={(event) => onClick(event.target?.value as string)}
          defaultValue=""
          onBlur={onBlur}
          disabled={disabled}
          data-testid={`${id}-select`}
          SelectDisplayProps={{
            role: 'combobox',
          }}
          MenuProps={{
            PaperProps: {
              role: 'tab',
            },
          }}
        >
          {lists?.map((item: string, index: number) => {
            return (
              <MenuItemWrapper key={`specialist${index}`} value={item}>
                {item}
              </MenuItemWrapper>
            )
          })}
        </SelectWrapper>
      </FormControlSelect>
      {error && (
        <LabelInputError alignSelf={'flex-start'} id={`${id}-error`}>
          {textError}
        </LabelInputError>
      )}
    </>
  )
}
